import React from "react";
import { IPaymentTracking } from "../interfaces/paymentTracking";
import { getBookingWithDoctorId } from "../services/booking.service";
import { useError } from "./ErrorModal";
import { useUser } from "./UserStore";
export const BookingListContext = React.createContext<{
  bookings: IPaymentTracking[];
  setBookings: (data: IPaymentTracking[]) => void;
  fetchBookings: () => Promise<void>;
  listUid: string[];
  isLoadingBookings: boolean;
}>({
  bookings: [],
  setBookings: (_: IPaymentTracking[]) => {},
  fetchBookings: async () => {},
  listUid: [],
  isLoadingBookings: false,
});

interface Props {
  children?: JSX.Element;
}

export default function BookingListProvider(props: Props) {
  const [bookings, setBookings] = React.useState<IPaymentTracking[]>([]);
  const [isLoadingBookings, setIsLoadingBookings] =
    React.useState<boolean>(false);
  const [listUid, setListUid] = React.useState<string[]>([]);
  const { userData } = useUser();
  const { onError } = useError();

  const fetchBookings = React.useCallback(async () => {
    if (!userData?.uid) return;
    setIsLoadingBookings(true);
    try {
      const { data } = await getBookingWithDoctorId(userData?.uid);

      const newListUid = data.map((b: IPaymentTracking) => {
        return b.uid;
      });

      setListUid(newListUid);
      setBookings(data);
    } catch (error) {
      onError(error as any);
    } finally {
      setIsLoadingBookings(false);
    }
  }, [userData?.uid, onError]);
  return (
    <BookingListContext.Provider
      value={{
        bookings,
        fetchBookings,
        setBookings,
        listUid,
        isLoadingBookings,
      }}
    >
      {props.children}
    </BookingListContext.Provider>
  );
}

export const useBookingsList = () => React.useContext(BookingListContext);
